import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';

export default class commentComponent extends Component {
  @service('current-user') currentUser;

  @action
  insertNew(element) {
    this.animateIn(element);
  }

  @action
  onDelete() {
    this.args.comment.destroyRecord();
  }

  get active() {
    if (this.args.interactive === false) return false;
    if (this.args?.comment?.author?.get('id') != this.currentUser.id) {
      return false;
    }
    if (this.args.active) {
      return this.args.active();
    } else {
      return false;
    }
  }

  @action
  animateIn(element) {
    setTimeout(() => {
      element.classList.remove('opacity-0', 'translate-x-2');
    }, 100);
  }
}
